import {
  LuAngry,
  LuAperture,
  LuArchive,
  LuAreaChart,
  LuBarChartBig,
  LuBarChartHorizontalBig,
  LuBookOpenCheck,
  LuContainer,
  LuFile,
  LuFileEdit,
  LuFileInput,
  LuFileMinus2,
  LuFileOutput,
  LuFilePlus2,
  LuFileX,
  LuLineChart,
  LuPieChart,
  LuPopcorn,
  LuShapes,
  LuStore,
  LuTable,
  LuTable2,
  LuTablets,
  LuUser2,
  LuUserCheck,
  LuUserCog,
  LuUsers,
  LuUsers2,
} from "react-icons/lu";
import {
  MdOutlineFeed,
  MdOutlineTopic,
  MdOutlineReport,
  MdOutlineForum,
} from "react-icons/md";
import { HiHashtag, HiOutlineNewspaper } from "react-icons/hi2";
import { FaRegObjectUngroup } from "react-icons/fa";
import { TfiLayoutMediaRight } from "react-icons/tfi";
import { VscTools } from "react-icons/vsc";
import { MenuItemType, MenuType } from "../types/menu.type";
import { ContainerOwnProps } from "@mui/material";
import { INavItem } from "../types/nav.type";
import { TbCategory } from "react-icons/tb";
import { ModeType } from "../types/mode.type";

const HEADER_HEIGHT: string = "50px";
const NAVBAR_HEIGHT: string = "42px";
const SIDEBAR_MINWIDTH: string = "72px";
const SIDEBAR_MAXWIDTH: string = "260px";
const MOBILE_CONTAINER: ContainerOwnProps["maxWidth"] = "sm";

const LOAI_CHIET_KHAU = [
  {
    value: "1",
    label: "Chiết khấu hóa đơn",
  },
  {
    value: "2",
    label: "Chiết khẩu sản phẩm",
  },
];

const MENUS: MenuType[] = [
  {
    subheader: "Tổng quan",
    items: [
      {
        text: "Thống kê bán hàng",
        path: "/dashboard",
        Icon: LuLineChart,
      },
    ],
  },
  {
    subheader: "Quản lý siêu thị",
    items: [
      { text: "Danh sách Sản phẩm", Icon: LuShapes, path: "/list/hanghoa" },
      { text: "Nhóm Sản phẩm", Icon: LuContainer, path: "/list/nhomhang" },
      { text: "Quy đổi đơn vị tính", Icon: LuAperture, path: "/list/dmqddvt" },
      { text: "Tồn đầu kỳ", Icon: LuArchive, path: "/list/cdvt" },
      { text: "Kiểm kê", Icon: LuBookOpenCheck, path: "/list/pkk" },
      { text: "Phiếu bán lẻ", Icon: LuFile, path: "/list/pbl" },
      { text: "Trả hàng", Icon: LuFileEdit, path: "/list/hd7" },
      { text: "Nhập hàng", Icon: LuFileInput, path: "/list/pn1" },
      { text: "Trả hàng nhập", Icon: LuFileOutput, path: "/list/pn5" },
      { text: "Xuất hủy", Icon: LuFileX, path: "/list/pxk" },
    ],
  },
  {
    subheader: "Quản lý quán ăn",
    items: [
      { text: "Danh sách món", Icon: LuPopcorn, path: "/list/monan" },
      { text: "Nhóm món", Icon: LuContainer, path: "/list/nhommon" },
      { text: "Đơn hàng", Icon: LuFile, path: "/list/hd_nh" },
      { text: "Danh sách bàn", Icon: LuTable, path: "/list/dmban" },
      { text: "Nhóm bàn", Icon: LuTable2, path: "/list/nhomban" },
    ],
  },
  {
    subheader: "Thu chi",
    items: [
      { text: "Phiếu thu", Icon: LuFilePlus2, path: "/list/pt1" },
      { text: "Phiếu chi", Icon: LuFileMinus2, path: "/list/pc1" },
      // { text: "Sổ quỹ", Icon: LuCoins, path: "/report/soquy" },
    ],
  },
  {
    subheader: "Đối tác",
    items: [
      { text: "Khách hàng", Icon: LuUser2, path: "/list/customer" },
      { text: "Nhóm khách", Icon: LuUsers, path: "/list/dmnhkh" },
      { text: "Nhà cung cấp", Icon: LuUserCheck, path: "/list/dmncc" },
      { text: "Nhóm nhà cung cấp", Icon: LuUsers2, path: "/list/dmnhncc" },
    ],
  },
  {
    subheader: "Hệ thống",
    items: [
      {
        text: "Nhóm người dùng và phân quyền",
        Icon: LuUsers,
        path: "/list/usergroup",
      },
      {
        text: "Người dùng",
        Icon: LuUser2,
        path: "/list/participant",
      },
      { text: "Đơn vị tính", Icon: LuTablets, path: "/list/dmdvt" },
      {
        text: "Chi nhánh",
        Icon: LuStore,
        path: "/list/dmkho",
      },
    ],
  },
];

const POST_MODES: { label: string; value: ModeType }[] = [
  {
    label: "Công khai",
    value: "public",
  },
  {
    label: "Bạn bè",
    value: "friends",
  },
  {
    label: "Ẩn danh",
    value: "anonymous",
  },
  {
    label: "Riêng tư",
    value: "private",
  },
];

const HEADER_OPTIONS: MenuItemType[] = [];

const NAVBAR_ITEMS: INavItem[] = [
  {
    text: "Tổng quan",
    link: "/",
    show: true,
    endIcon: <LuBarChartBig size={16} />,
  },
  {
    text: "Feed",
    endIcon: <HiOutlineNewspaper size={16} />,
    subs: [
      {
        text: "Bài viết",
        Icon: <MdOutlineFeed size={16} />,
        link: "/list/posts",
        module: "posts",
      },
      {
        text: "Tố cáo bài viết",
        Icon: <MdOutlineReport size={16} />,
        link: "/list/reportlist",
        module: "reportlist",
      },
      {
        text: "Hashtag",
        Icon: <HiHashtag size={16} />,
        link: "/list/hashtags",
        module: "hashtags",
      },
    ],
  },
  {
    text: "Forum",
    endIcon: <HiOutlineNewspaper size={16} />,
    subs: [
      {
        text: "Bài viết",
        Icon: <MdOutlineForum size={16} />,
        link: "/list/forumposts",
        module: "forumposts",
      },
      {
        text: "Danh mục",
        Icon: <TbCategory size={16} />,
        link: "/list/socialcategories",
        module: "socialcategories",
      },
      {
        text: "Chủ đề",
        Icon: <MdOutlineTopic size={16} />,
        link: "/list/topic",
        module: "topic",
      },
    ],
  },
  {
    text: "Hình ảnh",
    endIcon: <TfiLayoutMediaRight size={16} />,
    subs: [
      {
        text: "Logo",
        link: "/list/logo",
        module: "banner",
      },
      {
        text: "Banner Feed",
        link: "/list/banner_feed",
        module: "banner",
      },
      {
        text: "Banner Forum",
        link: "/list/banner_forum",
        module: "banner",
      },
    ],
  },
  {
    text: "Quản lý",
    endIcon: <VscTools size={16} />,
    subs: [
      {
        text: "Liên hệ khiếu nại",
        Icon: <LuAngry size={16} />,
        link: "/list/complaint",
        module: "complaint",
      },
      {
        text: "Nhóm liên hệ",
        Icon: <FaRegObjectUngroup size={16} />,
        link: "/list/complaint_group",
        module: "complaint_group",
      },
      {
        text: "Danh sách người dùng",
        Icon: <LuUserCog size={16} />,
        link: "/list/participant",
        module: "participant",
      },
      {
        text: "Nhóm người dùng",
        Icon: <LuUsers size={16} />,
        link: "/list/usergroup",
        module: "usergroup",
      },
    ],
  },
  {
    text: "Thống kê",
    endIcon: <LuPieChart size={16} />,
    subs: [
      {
        text: "Người dùng đăng ký",
        Icon: <LuBarChartBig size={16} />,
        link: "/report/fos_rpusers",
        module: "fos_rpusers",
      },
      {
        text: "Bài đăng",
        Icon: <LuAreaChart size={16} />,
        link: "/report/fos_rpposts",
        module: "fos_rpposts",
      },
      {
        text: "Bình luận",
        Icon: <LuBarChartHorizontalBig size={16} />,
        link: "/report/fos_rpcomments",
        module: "fos_rpcomments",
      },
    ],
  },
];

const BANNER_FEED_POSTION_OPTIONS: { label: string; value: string }[] = [
  {
    label: "Giữa trên",
    value: "feed_top_center",
  },
  {
    label: "Phải trên",
    value: "feed_top_right",
  },
  {
    label: "Phải dưới",
    value: "feed_bottom_right",
  },
  {
    label: "Trái dưới",
    value: "feed_bottom_left",
  },
];
const BANNER_FORUM_POSTION_OPTIONS: { label: string; value: string }[] = [
  {
    label: "Trái trên",
    value: "forum_top_left",
  },
  {
    label: "Trái dưới",
    value: "forum_bottom_left",
  },
  {
    label: "Cuối bài viết",
    value: "forum_bottom_article",
  },
];

const STORE_KEY = "store_key";
const BILL_KEY = "bill_key";

export {
  HEADER_HEIGHT,
  SIDEBAR_MINWIDTH,
  SIDEBAR_MAXWIDTH,
  MENUS,
  HEADER_OPTIONS,
  STORE_KEY,
  BILL_KEY,
  MOBILE_CONTAINER,
  NAVBAR_HEIGHT,
  NAVBAR_ITEMS,
  LOAI_CHIET_KHAU,
  POST_MODES,
  BANNER_FEED_POSTION_OPTIONS,
  BANNER_FORUM_POSTION_OPTIONS,
};
